<template>
    <div class="music-now-playing">
        <div class="music-now-layout">
            <div :class="['music-now-cover', {'music-now-cover--placeholder': !coverUrl}]">
                <img v-if="coverUrl" :src="coverUrl" @error="coverError = true">
                <svg v-else width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>
            </div>

            <div class="music-now-body">
                <div class="music-now-header">
                    <div class="music-now-name">{{ ms.displayName.value }}</div>
                    <div v-if="isTrack && track.artist" class="music-now-artist">{{ track.artist }}</div>
                    <div v-else class="music-now-meta">{{ ms.displaySubtext.value }}</div>
                </div>

                <div :class="['music-now-eq', {'music-now-eq--paused': !ms.state.playing}]">
                    <span v-for="i in 24" :key="i" class="music-now-eq-bar"
                          :style="{height: barHeight(i) + '%', animationDelay: barDelay(i) + 's'}"></span>
                </div>

                <div v-if="isTrack && trackDetails.length" class="music-now-details">
                    <div v-for="d in trackDetails" :key="d.label" class="music-now-detail">
                        <span class="music-now-detail-label">{{ $t('common.music.detail_' + d.label) }}</span>
                        <span class="music-now-detail-value">{{ d.value }}</span>
                    </div>
                </div>

                <button class="music-now-collapse" @click="$emit('collapse')">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import musicService from './musicService'

export default {
    name: 'MusicNowPlaying',
    emits: ['collapse'],
    data() {
        return {
            coverError: false,
        }
    },
    computed: {
        ms() { return musicService },
        coverUrl() {
            if (this.coverError) return null
            if (musicService.state.currentStation?.favicon) return musicService.state.currentStation.favicon
            if (musicService.state.currentTrack?.hasCover && musicService.state.currentTrack.thumb) return musicService.state.currentTrack.thumb.medium
            return null
        },
        track() {
            return musicService.state.currentTrack
        },
        isTrack() {
            return !!this.track
        },
        trackDetails() {
            if (!this.track) return []
            const d = []
            if (this.track.tags?.album) d.push({ label: 'album', value: this.track.tags.album })
            if (this.track.tags?.genre) d.push({ label: 'genre', value: this.track.tags.genre })
            if (this.track.tags?.year) d.push({ label: 'year', value: this.track.tags.year })
            if (this.track.format) d.push({ label: 'format', value: this.track.format.toUpperCase() + (this.track.bitrate ? ' ' + Math.round(this.track.bitrate / 1000) + ' kbps' : '') })
            if (this.track.sizeText) d.push({ label: 'size', value: this.track.sizeText })
            return d
        },
    },
    methods: {
        barHeight(i) {
            return 30 + ((i * 37 + 13) % 71)
        },
        barDelay(i) {
            return -((i * 0.12 + (i % 3) * 0.07) % 1.6)
        },
    },
    watch: {
        'ms.state.currentStation'() { this.coverError = false },
        'ms.state.currentTrack'() { this.coverError = false },
    },
}
</script>
